import React from "react";
import {
    Box, Checkbox, FormControl, FormControlLabel, Typography, useTheme
} from "@mui/material";
import { ControllerProps, useController } from "react-hook-form";
import { FieldPath, FieldValues } from "react-hook-form/dist/types";

type CheckboxInputProps<T extends FieldValues, TName extends FieldPath<T>> = Omit<ControllerProps<T, TName>, "render"> & {
    label?: React.ReactNode;
    hint?: string;
    errorMessage?: string;
    error?: boolean;
    inline?: boolean
    disabled?: boolean;
    labelPlacement?: "end" | "start";
    className?: string;
}

const CheckboxInput = <T extends FieldValues, TName extends FieldPath<T>>(props: CheckboxInputProps<T, TName>) => {

    const theme = useTheme();

    const { label, hint, errorMessage, error, inline = false, disabled, labelPlacement = "end", className, ...rest } = props;

    const { field } = useController({
        ...rest
    });

    const { onChange, value, name, ref, ...otherField } = field;
    return (
        <Box className={className}>
            <FormControl error={error} fullWidth sx={{ mt: -1.5, flexDirection: inline ? "row" : "column" }}>
                <FormControlLabel
                    name={name}
                    className={"input-label"}
                    value={value}
                    onChange={onChange}
                    labelPlacement={labelPlacement}
                    control={
                        <Checkbox
                            {...otherField}
                            className={"input-label"}
                            disabled={disabled}
                            checked={!!value}
                        />
                    }
                    label={label}
                    sx={{alignItems: "flex-start", color: theme.palette.thatsMe.textPrimary}}
                />
                {hint &&
                    <Typography className={"input-help"} variant={"body2"} component="div">
                        {hint}
                    </Typography>
                }
                {errorMessage &&
                    <Typography className={"error-message"} variant={"body2"} component="div">
                        {errorMessage}
                    </Typography>
                }
            </FormControl>
        </Box>
    )
}

export type { CheckboxInputProps }
export { CheckboxInput }
